import { cn } from '@/lib/utils'
import styles from '@/components/assets-explorer/assets-explorer.module.scss'
import { Skeleton } from '@/components/ui/skeleton'
import React from 'react'

export default function SubCategoriesSliderSkeleton() {
  return (
    <ul className={cn(styles.horizontalSlider)}>
      {Array.from({ length: 3 }).map((_, index) => (
        <li key={index}>
          <Skeleton className="tw-h-[36px] tw-w-32" />
        </li>
      ))}
    </ul>
  )
}
